import {
  LeaderExtendQuery,
  RoleTypes,
  RoleTypesAll,
  StatusTypes,
} from 'configs/constants';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';
import type { CreateUserDto } from 'services/openapi';
import { Roles } from 'configs/roles';

export enum ActiveUserSuccess {
  SUCCESS = 200,
}

export const ActiveUserSuccessDefined = {
  [ActiveUserSuccess.SUCCESS]: {
    message: 'Kích hoạt thành công',
  },
};

export enum InactiveUserSuccess {
  SUCCESS = 200,
}

export const InactiveUserSuccessDefined = {
  [InactiveUserSuccess.SUCCESS]: {
    message: 'Vô hiệu hóa thành công',
  },
};

export enum RemoveUserSuccess {
  SUCCESS = 200,
}

export const RemoveUserSuccessDefined = {
  [RemoveUserSuccess.SUCCESS]: {
    message: 'Xóa thành công',
  },
};
export type FilterType = {
  searchString?: string;
  isActive?: boolean | string;
  isDeleted?: boolean | string;
  role?:
    | Exclude<CreateUserDto['role'], 'SpAdm'>
    | CreateUserDto['objectType']
    | 'Tất cả';
  searchDetailContent?: string;
  compId?: string;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    searchString: urlParams?.get('searchString') ?? '',
    compId: urlParams?.get('compId') ?? urlParams?.get('companyId') ?? '',
    isActive: urlParams?.get('isActive') ?? StatusTypes['Tất cả'],
    isDeleted: urlParams?.get('isDeleted') ?? false,
    role: urlParams?.get('role') ?? RoleTypes['Tất cả'],
    searchDetailContent: urlParams?.get('searchDetailContent') ?? '',
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

export const convertSelectLeaderOptions = (data: any[]) => {
  if (!data || !data.length) return [];

  const all = Object.keys(LeaderExtendQuery).map((key: string) => {
    return {
      label: LeaderExtendQuery[key as keyof typeof LeaderExtendQuery],
      value: key,
    };
  });

  const leaders = data?.map((item) => {
    return {
      label: `${item?.fullName}-${normalizedPhoneNumber(item?.phoneNumber as unknown as string)}`,
      value: `${item?.fullName}-${item?.phoneNumber}`,
    };
  });

  return [...all, ...leaders];
};

type UserRoleOption = {
  label: string;
  value: Exclude<CreateUserDto['role'], 'SpAdm'> | CreateUserDto['objectType'];
};

export const getUserRoleOptions = (roles: string[]): UserRoleOption[] =>
  Object.entries(RoleTypesAll)
    .filter(([, value]: [string, string]) => {
      if (value === Roles.ADMIN) return roles.includes(Roles.SUPER_ADMIN);
      if (value === Roles.MC) {
        return roles.includes(Roles.SUPER_ADMIN) || roles.includes(Roles.ADMIN);
      }
      return true;
    })
    .map(([label, value]) => ({ label, value }));

export const convertSelectRoleOptions = (roles: string[]) => [
  { label: 'Tất cả', value: RoleTypes['Tất cả'] },
  ...getUserRoleOptions(roles),
];

export const convertSelectStatusOptions = () => {
  return Object.keys(StatusTypes).map((key: string) => {
    return {
      label: key,
      value: StatusTypes[key as keyof typeof StatusTypes],
    };
  });
};

export const convertSelectDeletedOptions = () => [
  { label: 'Tất cả', value: StatusTypes['Tất cả'] },
  { label: 'Đã xóa', value: 'true' },
  { label: 'Chưa xóa', value: 'false' },
];

export const exportHeadersCreateMultiUser = [
  'STT',
  'Tài khoản',
  'Tên tài khoản',
  'CCCD/MST',
  'Tiểu khoản TPBank',
  'Tiểu khoản BIDV',
  'Email',
  'Vai trò',
  'Doanh nghiệp/HTX',
  'Trạng thái',
  'Tên tài khoản VA BIDV',
];
